import type {IFormAddress} from '@models/onboarding-review/form-address';
import {ISection2Certification} from '@models/onboarding-review/section2-certification';
import {getCurrentISOTimestamp, matchesTodaysLocalDate} from '@utils/date-query';
import {action, computed, observable} from 'mobx';
import {IConfigurationValuesService} from '@services/ConfigurationValuesService';
import {formatAsLocalTimezone} from '@utils/date-format';

export interface ISection2CertificationStore extends Readonly<ISection2Certification> {
  readonly isSignedOnValid: boolean;
  readonly isDefaultToTodaysDate: boolean;
  initialise(): void;
  setBusinessAddress(address: IFormAddress): void;
  setBusinessName(name: string): void;
  setFirstName(name: string): void;
  setLastName(name: string): void;
  setDidAgreeToSign(agreed: boolean): void;
  setSignedOn(signedOn: string): void;
  setTitle(title: string): void;
}

const emptyAddress = {
  streetAddress: '',
  state: '',
  zipCode: '',
  city: ''
};

export class Section2CertificationStore implements ISection2CertificationStore {
  @observable
  businessAddress: IFormAddress = emptyAddress;

  @observable
  title: string = '';

  @observable
  businessName: string = '';

  @observable
  firstName: string = '';

  @observable
  lastName: string = '';

  @observable
  didAgreeToSign: boolean = false;

  @observable
  signedOn: string = '';

  constructor(
    private configurationValuesService: IConfigurationValuesService
  ) {
    if (configurationValuesService?.defaultTodaysDateToToday) {
      this.signedOn = formatAsLocalTimezone(
        getCurrentISOTimestamp()
      );
    }
  }

  @computed
  get isDefaultToTodaysDate(): boolean {
    return this.configurationValuesService?.defaultTodaysDateToToday
  }

  @computed
  get isSignedOnValid(): boolean {
    return matchesTodaysLocalDate(this.signedOn);
  }

  @action.bound
  initialise(): void {
    this.businessAddress = observable.object(emptyAddress);
    this.businessName = '';
    this.firstName = '';
    this.lastName = '';
    this.didAgreeToSign = false;
    this.signedOn = '';
  }

  @action.bound
  setBusinessAddress(address: IFormAddress): void {
    // unsure if we need to assign each field individually
    this.businessAddress = address;
  }

  @action.bound
  setBusinessName(name: string): void {
    this.businessName = name;
  }

  @action.bound
  setFirstName(name: string): void {
    this.firstName = name;
  }

  @action.bound
  setLastName(name: string): void {
    this.lastName = name;
  }

  @action.bound
  setDidAgreeToSign(agreed: boolean): void {
    this.didAgreeToSign = agreed;
  }

  @action.bound
  setSignedOn(signedOn: string): void {
    this.signedOn = signedOn;
  }

  @action.bound
  setTitle(title: string) {
    this.title = title;
  }
}



// WEBPACK FOOTER //
// ./src/stores/onboarding-review/section2-certification-store.ts